export const height_action = (data,type) => ({
    type: 'Height',
    payload: { 
      data: data,
      type: type
    }
  });
